/**
 * @generated SignedSource<<597249efa8324f581148e7ee56fbe023>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateBaselineVersionPhaseInput = {
  projectId: string;
  baselineVersionId: string;
  name: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type CreateBaselineVersionPhaseMutation$variables = {
  input: CreateBaselineVersionPhaseInput;
};
export type CreateBaselineVersionPhaseMutation$data = {
  readonly createBaselineVersionPhase: {
    readonly project: {
      readonly id: string;
    } | null;
  } | null;
};
export type CreateBaselineVersionPhaseMutation = {
  variables: CreateBaselineVersionPhaseMutation$variables;
  response: CreateBaselineVersionPhaseMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateBaselineVersionPhasePayload",
    "kind": "LinkedField",
    "name": "createBaselineVersionPhase",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectType",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateBaselineVersionPhaseMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateBaselineVersionPhaseMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "79b6593bdf28e1ff50e80fb80eca3664",
    "id": null,
    "metadata": {},
    "name": "CreateBaselineVersionPhaseMutation",
    "operationKind": "mutation",
    "text": "mutation CreateBaselineVersionPhaseMutation(\n  $input: CreateBaselineVersionPhaseInput!\n) {\n  createBaselineVersionPhase(input: $input) {\n    project {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c8897b0abcc5204f68617b743b78ad71";

export default node;
